<router-outlet></router-outlet>
<p-toast key="network" />
<p-toast
  key="error"
  styleClass="app-feedback-toast"
  position="bottom-center"
  [showTransformOptions]="'translateY(100%)'"
  [showTransitionOptions]="'250ms'"
  [hideTransitionOptions]="'250ms'"
/>
